var map = {
	"./chat.js": 90115,
	"./composition.js": 9505,
	"./config.js": 20351,
	"./enroll.js": 89644,
	"./examination.js": 41363,
	"./file.js": 81070,
	"./info.js": 23798,
	"./score.js": 5789,
	"./user.js": 50174
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82589;